"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.browserScreen = void 0;
function browserScreen() {
    const screenInfo = {
        width: ``,
        height: ``,
        colorDepth: ``,
        fontSmoothingEnabled: ``,
    };
    if (screen) {
        screenInfo.width = screen.width.toString();
        screenInfo.height = screen.height.toString();
        screenInfo.colorDepth = screen.colorDepth.toString();
    }
    screenInfo.fontSmoothingEnabled = browserFontSmoothingEnabled().toString();
    return screenInfo;
}
exports.browserScreen = browserScreen;
function browserFontSmoothingEnabled() {
    let i, j, imageData, alpha;
    const canvasNode = document.createElement('canvas');
    canvasNode.width = 35;
    canvasNode.height = 35;
    canvasNode.style.display = 'none';
    document.body.appendChild(canvasNode);
    const ctx = canvasNode.getContext('2d');
    if (ctx) {
        ctx.textBaseline = 'top';
        ctx.font = '32px Arial';
        ctx.fillStyle = 'black';
        ctx.strokeStyle = 'black';
        ctx.fillText('O', 0, 0);
        for (j = 8; j <= 32; j = j + 1) {
            for (i = 1; i <= 32; i = i + 1) {
                imageData = ctx.getImageData(i, j, 1, 1).data;
                alpha = imageData[3];
                if (alpha !== 255 && alpha !== 0) {
                    return true; // font-smoothing must be on.
                }
            }
        }
    }
    return false;
}
//# sourceMappingURL=screen.js.map